module.exports = __webpack_public_path__ + "img/pdf-invoice-logo.99dfe4a3.svg";